(() => {
  if (customElements.get('gi-straw-product')) return;
  class StrawProduct extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.variants = JSON.parse(this.dataset.variants);
      this.form = this.querySelector('.gsp__form');
      this.qty = this.form.elements.quantity;
      this.buy = this.querySelector('.gsp__buy');
      this.sticky = this.querySelector('.gsp__sticky');
      this.message = this.querySelector('.gsp__message');
      this.money = new Intl.NumberFormat('fr-FR', {style:'currency', currency:this.dataset.currency || 'EUR'});
      this.querySelector('[data-minus]').addEventListener('click', () => { this.qty.stepDown(); this.update(); });
      this.querySelector('[data-plus]').addEventListener('click', () => { this.qty.stepUp(); this.update(); });
      this.qty.addEventListener('input', () => this.update());
      this.form.elements.id.addEventListener('change', () => {
        const url = new URL(location.href); url.searchParams.set('variant', this.form.elements.id.value); history.replaceState({}, '', url);
        this.update();
      });
      this.form.addEventListener('submit', event => this.submit(event));
      this.querySelector('[data-sticky-buy]').addEventListener('click', () => {
        if (this.form.reportValidity()) this.form.requestSubmit();
        else this.form.scrollIntoView({block:'center',behavior:'auto'});
      });
      this.observer = new IntersectionObserver(entries => {
        const rect = entries[0].boundingClientRect;
        this.sticky.hidden = entries[0].isIntersecting || rect.top > 0;
      });
      this.observer.observe(this.buy);
      const main = this.querySelector('.gsp__main-image');
      const zoom = this.querySelector('.gsp__zoom');
      const zoomLink = this.querySelector('[data-zoom]');
      this.querySelectorAll('[data-photo]').forEach((thumb, index) => thumb.addEventListener('click', event => {
        event.preventDefault(); main.removeAttribute('srcset'); main.src = thumb.dataset.photo;
        main.alt = `Gourde blanche 1,2 L avec paille — photo ${index + 1}`;
        zoomLink.href = thumb.href; zoom.querySelector('img').src = thumb.href;
        this.querySelectorAll('[data-photo]').forEach(el => el.removeAttribute('aria-current'));
        thumb.setAttribute('aria-current', 'true');
      }));
      zoomLink?.addEventListener('click', event => { if (zoom.showModal) {event.preventDefault(); zoom.showModal();} });
      this.querySelector('[data-close-zoom]').addEventListener('click', () => zoom.close());
      zoom.addEventListener('click', event => { if (event.target === zoom) zoom.close(); });
      this.update();
    }
    disconnectedCallback() { this.observer?.disconnect(); }
    update() {
      const variant = this.variants.find(v => String(v.id) === this.form.elements.id.value);
      this.variant = variant;
      const quantity = Number(this.qty.value);
      const total = variant.price * (Number.isFinite(quantity) && quantity > 0 ? quantity : 1);
      this.querySelector('[data-unit-price]').textContent = this.money.format(variant.price / 100);
      this.querySelector('[data-total]').textContent = this.money.format(total / 100);
      this.querySelector('[data-sticky-price]').textContent = this.money.format(total / 100);
      this.querySelector('[data-availability]').textContent = variant.available ? 'Disponible' : 'Indisponible';
      this.querySelector('[data-buy-label]').textContent = variant.available ? 'Ajouter au panier' : 'Indisponible';
      this.buy.disabled = this.busy || !variant.available;
      this.querySelector('[data-sticky-buy]').disabled = this.busy || !variant.available;
    }
    async submit(event) {
      event.preventDefault();
      if (this.busy || !this.variant.available || !this.form.reportValidity()) return;
      this.busy = true; this.update(); this.form.setAttribute('aria-busy','true');
      this.querySelector('[data-buy-label]').textContent = 'Ajout en cours…';
      this.message.hidden = true;
      let added = false;
      try {
        const response = await fetch(this.form.action.replace(/\/add\/?$/, '/add.js'), {
          method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({items:[{id:this.form.elements.id.value,quantity:Number(this.qty.value)}]})
        });
        if (!response.ok) {
          const error = await response.json();
          throw new Error(error.description || 'Cet ajout n’est pas disponible. Vérifiez la quantité choisie.');
        }
        added = true;
        this.message.textContent = 'Ajouté au panier. Ouverture de votre panier…'; this.message.hidden = false;
        location.assign(this.dataset.cartUrl + '?view=gi-product');
      } catch (error) {
        this.message.textContent = added ? 'Votre article a été ajouté. Ouvrez le panier avec l’icône en haut de la page.' : (error instanceof TypeError ? 'Connexion interrompue : vérifiez votre panier avant de réessayer pour éviter un ajout en double.' : error.message);
        this.message.hidden = false;
        if (matchMedia('(max-width: 899px)').matches) this.form.scrollIntoView({block:'center',behavior:'auto'});
      } finally {
        if (!added) {this.busy = false;this.form.removeAttribute('aria-busy');this.update();}
      }
    }
  }
  customElements.define('gi-straw-product', StrawProduct);
})();
